import React, { FC } from "react";
import {
  Background,
  MiniMap,
  Node,
  Edge,
  ReactFlow,
  Controls,
  BackgroundVariant,
  NodeChange,
  EdgeChange,
} from "@xyflow/react";

import { DEFAULT_EDGE_OPTIONS, NODE_TYPES, PRO_OPTIONS } from "./OrgChart.constants";

interface OrgChart {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: (nodeChange: NodeChange<Node>[]) => void;
  onEdgesChange: (edgeChange: EdgeChange<Edge>[]) => void;
}

const OrgChart: FC<OrgChart> = ({ nodes, edges, onNodesChange, onEdgesChange }) => {
  return (
    <div style={{ width: "100%", height: "800px" }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        defaultEdgeOptions={DEFAULT_EDGE_OPTIONS}
        minZoom={-Infinity}
        maxZoom={Infinity}
        nodeTypes={NODE_TYPES}
        proOptions={PRO_OPTIONS}
        nodesConnectable={false}
        elementsSelectable={false}
        nodesDraggable={false}
      >
        <MiniMap zoomable pannable />
        <Background variant={BackgroundVariant.Dots} gap={10} size={1.5} />
        <Controls showInteractive={false} />
      </ReactFlow>
    </div>
  );
};

export default OrgChart;
